import debounce from '../utils/debounce'
import Step from '../Step'
import { translate, scale, rotate, transitionDuration, impressSupported } from '../utils'
import initStepData from '../utils/initStepData'
import reverseData from '../utils/reverseData'
import computeScale from '../utils/computeScale'
import {mapState, mapGetters, mapActions} from 'vuex'
import * as types  from '@/vuex/types'
import util from '@/utils'

export default {
  props: {
    /* steps param array
     * 各动画的位置参数 */
    steps: {
      type: Array,
      required: true,
    },

    config: {
      type: Object,
    },
  },

  components: {
    Step,
  },
  computed: {
      ...mapState({
        teachIndex: state => state.teachIndex,
        impressremain: state => state.status.impressremain
      })
    },
  methods: {
    ...mapActions({
        setTeachIndex: 'setTeachIndex',
        setImpressRemain : 'setImpressRemain'
      }),
    nextStep() {
      // 教案翻页 返回顶部
      this.goBackTop()
      //增加頁面內段落動畫功能
      var direction = 'down';
      this.dobuild = false;
      let subs = this.stepsData[this.stepIndex].props?this.stepsData[this.stepIndex].props.subs:null;
      if(subs && this.lines != subs.length && this.stepsData[this.stepIndex].rebuild){
        while(this.lines < subs.length){
          let temp = subs[this.lines];
          if(temp.rebuild){
            this.dobuild = true;
            temp.style = temp.nextStyle;
            this.lines++;
            break;
          }
          this.lines++;
        }

      }
      // //add
      // if(this.stepIndex >= this.steps.length - 1 && !this.stepsData[this.stepIndex].rebuild){
      //    this.dobuild = false;
      // }
      const stepIndex = Number(this.stepIndex) + 1;
      this.gotoStep(stepIndex,direction,this.slowTransitionDuration);
    },
    prevStep() {
      // 教案翻页 返回顶部
      this.goBackTop()
      this.dobuild = false;
      var direction = 'up';
      let subs = this.stepsData[this.stepIndex].props?this.stepsData[this.stepIndex].props.subs:[];
      if(this.lines && this.lines > 0 && this.stepsData[this.stepIndex].rebuild){
        while(this.lines > 0 ){
          let temp = subs[this.lines];
          if(temp.rebuild){
            this.dobuild = true;
            temp.style = temp.initStyle;
            break;
          }
          this.lines--;
        }
        // console.log(this.lines)
      }

      //add
      // if(this.stepIndex <=0){
      //   return;
      // }

      const stepIndex = this.stepIndex <= 0 ? this.steps.length - 1 : this.stepIndex - 1
      this.gotoStep(stepIndex,direction,this.slowTransitionDuration);

    },
    gotoStep(stepIndex,direction,time) {
      // 教案翻页 返回顶部
      this.goBackTop()
      if(this.dobuild){
        return;
      }
     this.dobuild=true;//add 左右滑动需要使用 自己添加的
      direction = direction || 'down';
      /* trigger when leave step, like impress.js
       * 当离开当前step时即触发，不用等下一个stepenter所以不用setTimeout
       * impress.js就是这么处理的，先这样 */
      if (stepIndex !== this.stepIndex) {
        //還原該頁面的初始狀態
        if(this.stepIndex && this.stepsData[this.stepIndex].rebuild){
          let subs = this.stepsData[this.stepIndex].props.subs;
          if(subs && subs.length){
            for(var i in subs){
              subs[i].clz = subs[i].initClz;
              subs[i].style = subs[i].initStyle;
            }
          }
        }
        this.$emit('impress:stepleave', this.stepIndex)
      }
      if(stepIndex >= this.stepsData.length){
        stepIndex -= this.stepsData.length
      }
      this.stepIndex = stepIndex
      const currentData = this.stepsData[stepIndex]
      //當前動畫狀態重置
      this.lines = 0;
      this.stepClass = currentData.id
      const target = reverseData(currentData)
      const duration = currentData.transitionDuration||time || this.transitionDuration
      const timingFunction = currentData.transitionTimingFunction ||
        this.config.transitionTimingFunction || 'ease'

      /* default perspective 1000px */
      const perspective = `${(this.config.perspective || 1000) / this.containerScale}px`

      /*by sw 添加背景样式*/
      this.background = this.stepsData[stepIndex].bgPic.indexOf('#') == -1
                      ? 'url('+ types.FILE_SERVER_URL + this.stepsData[stepIndex].bgPic+') 0% 0% / cover no-repeat'
                      : '#FFF'
      this.initialRootStyle = {
        /* perspective is for the elements in step which have transform css setting
         * if there are no transform elements, perspective is meaningless
         * 一开始没看出用处，后来发现perspective是给每个step里设置了transform的元素产生视角用的，若step中没有3d变换的元素是没什么用 */
        perspective,
        transitionDuration: duration,
        transform: scale(target.scale * this.containerScale),
        /*by sw 添加背景样式*/
        background: this.background
      }
      this.canvasStyle = {
        transitionDuration: duration,
        transitionTimingFunction: timingFunction,
        transform: rotate(target.rotate) + translate(target.translate),
      }
      /* when switch steps too quickly,
       * only after the duration time between steps, trigger `impress:stepenter` event
       * 当快速切换step时，超过duration时间之后的step才触发impress:stepenter */
      clearTimeout(this.stepEnterTimeout)
      this.stepEnterTimeout = setTimeout(() => {
        this.$emit('impress:stepenter', this.stepIndex);
      }, transitionDuration(duration, true))
      this.setTeachIndex(this.stepIndex);
    },
    // 翻页回到顶部 教案
    goBackTop() {
      let url = location.href;
      //type = 1 教案 type = 2 课件
      let type = util.getUrlParam(url, "type");
      if(type == 1) {
        const container = document.querySelector('.courseimpress-scroll');
        container.scrollTop = 0;
      } else if(type == 2) {
        return
      }
    }
  },

  beforeMount() {
    this.impressSupported = impressSupported
    if (this.config.fullscreen !== false) {
      this.config.fullscreen = true
    }
    this.transitionDuration = transitionDuration(this.config.transitionDuration || 1000)
    this.slowTransitionDuration = transitionDuration(this.config.slowTransitionDuration || 1200);
    // setTimeout(() => {
      this.stepsData = this.steps.map((data, i) => {
        const stepData = initStepData(data)
        stepData.content = data.content
        stepData.props = data.props
        stepData.id = data.id || `step-${i}`
        //stepData.component = data.component
        stepData.component = this.config.component
        stepData.rebuild = data.rebuild,
        /*by sw*/
        stepData.bgPic = data.bgPic
        return stepData
      })
    // }, 1)
  },

  mounted() {
    // 加载是默认显示第一页
    this.$on('impress:goto', (index) => {
      this.gotoStep(index)
    })
    if (this.config.fullscreen) {
      this.resize = debounce(() => {
        this.containerScale = computeScale({
          width: window.innerWidth,
          height: window.innerHeight,
        }, this.config)
        this.initialRootStyle.transitionDuration=this.transitionDuration;
        this.initialRootStyle.transform = scale(this.containerScale);
        this.initialRootStyle.background = this.background;
        this.canvasStyle.transitionDuration=this.transitionDuration;
        this.gotoStep(this.stepIndex)
      }, 250)
      this.containerScale = computeScale({
        width: window.innerWidth,
        height: window.innerHeight,
      }, this.config)
      window.addEventListener('resize', this.resize)
    } else {
      const parent = this.$refs.root.offsetParent
      this.containerScale = computeScale({
        width: parent.clientWidth,
        height: parent.clientHeight,
      }, this.config)
    }
    // 授课ppt v-if问题
    if(!this.impressremain){
      this.setTeachIndex(0);
    }
    this.gotoStep(this.teachIndex);
  },

  beforeDestroy() {
    if (this.config.fullscreen) {
      window.removeEventListener('resize', this.resize)
    }
  },

  data() {
    return {
      impressSupported: true,
      initialRootStyle: null,
      canvasStyle: null,
      stepIndex: null,
      lastStepIndex: null,
      stepsData: [],
      transitionDuration: '',
      slowTransitionDuration:'',
      /* for debounce impress:stepenter event in steps duration time
       * 给每个step enter之后的timeout用 */
      stepEnterTimeout: null,
      containerScale: 1,
      stepClass: '',
      dobuild : false,
      lines : 0,
      /*by sw*/
      background: null
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/plugin/impress/Viewport/viewport.js